import { useCallback, useEffect, useState } from 'react';

import { useFlags } from 'launchdarkly-react-client-sdk';
import { parseJwt } from 'utils/decodeJWT';

import { Tier } from 'services/api/tier/types';
import { Member } from 'services/api/member/types';
import { getMember, getTier, getIsClub } from 'services/api';
import { verifyActiveFlag } from 'services/vale-milhas/index.';

export function useMember() {
  const [userData, setUserData] = useState<Member>();
  const [tierData, setTierData] = useState<Tier>();
  const [isClubSmls, setIsClubSmls] = useState(false);
  const [isValeMilhas, setIsValeMilhas] = useState(false);

  const { apiDomain } = useFlags();
  const getUserData = useCallback(async () => {
    const responseUserData = await getMember(apiDomain);
    setUserData(responseUserData);
  }, [apiDomain]);

  const getTierData = useCallback(async () => {
    const responseTierData = await getTier(apiDomain);
    setTierData(responseTierData);
  }, [apiDomain]);

  const handleGetIsClub = useCallback(async () => {
    getIsClub(apiDomain).then((result) => setIsClubSmls(result));
  }, [apiDomain]);

  const handleGetIsValeMilhas = useCallback(async () => {
    const getToken = parseJwt(`${localStorage.getItem('session-token')}`);
    const memberNumVoeBiz = getToken?.sub.split('|')[2];
    verifyActiveFlag(memberNumVoeBiz).then((result) => setIsValeMilhas(result));
  }, []);

  useEffect(() => {
    getUserData();
  }, [getUserData]);

  useEffect(() => {
    getTierData();
  }, [getTierData]);

  useEffect(() => {
    handleGetIsClub();
  }, [handleGetIsClub]);

  useEffect(() => {
    handleGetIsValeMilhas();
  }, [handleGetIsValeMilhas]);

  return { userData, tierData, isClubSmls, isValeMilhas };
}
